import { VALDATA_MISSING } from '../../../src/constants/api-error-enums';
import { trackCompleteIdentityValidation } from '../../helpers/gtm';
import OrchCustomData from '../../helpers/orch-custom-data';
import completeIdentityValidation from '../complete-identity-validation';

/*
 * Buttonless wrapper for ompleteIdentityValidation api.
 * This is what is bound to "V" namespace for merchant to
 * call in integrated Vsb flows. Wrapper is needed to keep
 * integrated/buttonless specific logic and response handling
 * separate from ompleteIdentityValidation orch api
 */
const completeIdentityValidationForButtonless = data => {
  return new Promise(resolve => {
    const preferredNetwork = OrchCustomData.srcSdks.orchConfig.preferredNetwork;
    // VCO-15055 - for VSB send validation response as per EMVCo1.1 for empty otpCode
    const vsbGtmData = { isError: false, isRequest: true, isVsb: true };
    trackCompleteIdentityValidation(OrchCustomData, vsbGtmData, preferredNetwork);
    const otpCode = data?.validationData || data?.otpCode;
    if (!otpCode) {
      return resolve({ error: { reason: VALDATA_MISSING }, isValidationComplete: false });
    }
    return resolve(completeIdentityValidation(data));
  });
};

export default completeIdentityValidationForButtonless;
